(() => {
  const sectionInstances = new WeakMap();
  const DESKTOP_BREAKPOINT = 990;

  // Feeds the sticky card stack the measurements CSS can't take itself: the live
  // heading-group height and the tallest card (all cards share it so none shows
  // below the one covering it). Also turns stacking off when the tallest card
  // can't fit under the sticky top — otherwise its lower part stays unreachable
  // behind the next card.
  const initSection = (section) => {
    if (!section) return;

    destroySection(section);

    const root = section.querySelector(".steps--overlap");
    if (!root) return;

    const header = root.querySelector(".steps__header");
    const cards = [...root.querySelectorAll(".steps__card")];
    const instance = { root, active: true };

    const resolveLength = (value) => {
      if (!value) return 0;
      const probe = document.createElement("div");
      probe.style.cssText = `position:absolute;visibility:hidden;height:${value.trim()}`;
      root.appendChild(probe);
      const px = probe.getBoundingClientRect().height;
      probe.remove();
      return px;
    };

    const syncHeaderHeight = () => {
      if (!instance.active || !header) return;
      root.style.setProperty(
        "--steps-header-height",
        `${header.offsetHeight}px`
      );
    };

    const syncOverlap = () => {
      if (!instance.active || !cards.length) return;

      root.classList.remove("steps--overlap-off");
      root.style.removeProperty("--steps-card-min-height");

      if (window.innerWidth < DESKTOP_BREAKPOINT) return;

      const tallest = cards.reduce(
        (max, card) => Math.max(max, card.offsetHeight),
        0
      );

      // Room the pinned stack has under its sticky top. The theme header only
      // eats into it while sticky — its custom element is present exactly then,
      // matching the offset the SCSS applies.
      const gap = resolveLength(
        getComputedStyle(root).getPropertyValue("--steps-sticky-gap")
      );
      const stuckThemeHeader = document.querySelector("sticky-header")
        ? parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue(
              "--header-height"
            )
          ) || 0
        : 0;
      const available =
        window.innerHeight - gap - header.offsetHeight - stuckThemeHeader;

      if (tallest > available) {
        root.classList.add("steps--overlap-off");
        return;
      }

      root.style.setProperty("--steps-card-min-height", `${tallest}px`);
    };

    const sync = () => {
      syncHeaderHeight();
      syncOverlap();
    };

    const onResize = () => {
      if (instance.frame) cancelAnimationFrame(instance.frame);
      instance.frame = requestAnimationFrame(sync);
    };

    sync();

    if (document.fonts) {
      document.fonts.ready.then(sync);
    }

    if (header) {
      instance.resizeObserver = new ResizeObserver(sync);
      instance.resizeObserver.observe(header);
    }

    window.addEventListener("resize", onResize);
    instance.onResize = onResize;

    sectionInstances.set(section, instance);
  };

  const destroySection = (section) => {
    const instance = sectionInstances.get(section);
    if (!instance) return;

    instance.active = false;

    if (instance.frame) cancelAnimationFrame(instance.frame);
    if (instance.resizeObserver) instance.resizeObserver.disconnect();
    window.removeEventListener("resize", instance.onResize);

    instance.root.classList.remove("steps--overlap-off");
    instance.root.style.removeProperty("--steps-header-height");
    instance.root.style.removeProperty("--steps-card-min-height");

    sectionInstances.delete(section);
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    destroySection(event.target);
  });
})();
